import React from "react";
import "./FleetCoreFuelAccountabilityProblem.css";

import fleetcoreFuelAccountabilityProblemDepotNightJpg from "../../images/fleetcore-fuel-accountability-problem-depot-night.jpg";
import fleetcoreFuelAccountabilityProblemDepotNightWebp from "../../images/fleetcore-fuel-accountability-problem-depot-night.webp";
import fleetcoreFuelAccountabilityProblemFragmentedEvidenceModel from "../../images/fleetcore-fuel-accountability-problem-fragmented-evidence-model.svg";

export default function FleetCoreFuelAccountabilityProblem() {
  return (
    <section className="fleetcore-fuel-accountability-problem" id="fleetcore-accountability-gap" aria-labelledby="fleetcore-fuel-accountability-problem-title">
      <div className="fleetcore-fuel-accountability-problem__inner">
        <div className="fleetcore-fuel-accountability-problem__copy">
          <p className="fleetcore-fuel-accountability-problem__eyebrow">THE ACCOUNTABILITY GAP</p>
          <h2 id="fleetcore-fuel-accountability-problem-title">Fuel loss hides between disconnected records.</h2>
          <p className="fleetcore-fuel-accountability-problem__body">A fuel slip confirms litres. A logbook records a journey. An odometer shows distance. None of them proves the complete refuelling event on its own.</p>
          <p className="fleetcore-fuel-accountability-problem__principle">When evidence is separated, exceptions are difficult to see.</p>
        </div>
        <div className="fleetcore-fuel-accountability-problem__visual">
          <picture><source srcSet={fleetcoreFuelAccountabilityProblemDepotNightWebp} type="image/webp" /><img className="fleetcore-fuel-accountability-problem__photo" src={fleetcoreFuelAccountabilityProblemDepotNightJpg} alt="Commercial fleet driver refuelling at night with disconnected paper and digital records nearby" /></picture>
          <img className="fleetcore-fuel-accountability-problem__model" src={fleetcoreFuelAccountabilityProblemFragmentedEvidenceModel} alt="Driver, vehicle, odometer and fuel slip shown as four disconnected records" />
        </div>
      </div>
    </section>
  );
}
